const Shift = () => import('@/modules/shift/views/Shift.vue')

export const shiftRoutes = [
  {
    name: 'shift',
    path: '/shift',
    component: Shift,
  },
]
